<template>
  <v-card class="pa-5 card-shadow" rounded="0">
    <v-row no-gutters justify="start">
      <back-btn class="hide-on-print" />
    </v-row>

    <v-row class="mt-4">
      <v-col
        v-for="(box, index) in boxes"
        :key="index"
        cols="12"
        sm="6"
        md="4"
        lg="3"
      >
        <resource-card
          :title="box.title"
          :text="box.text"
          :url="box.url"
          :policy-type="box.deliveryPolicy"
          :color="box.color"
        />
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
  import { mapActions } from 'vuex';
  import Document from '@/mixins/document';
  import ResourceCard from './ResourceCard.vue';

  export default {
    name: 'LinkBoxes',
    components: {
      ResourceCard,
    },
    mixins: [Document],
    data() {
      return {
        boxes: [
          {
            title: 'Reporte de Backorder',
            text: 'IR A VÍNCULO',
            color: '#D7263D',
            url: 'http://200.79.162.123/reportes/folios/folios.asp',
            deliveryPolicy: null,
          },
          {
            title: 'Reporte pedidos pendientes SAP',
            text: 'IR A VÍNCULO',
            color: '#DE639A',
            url: 'http://172.16.171.10/pro/reportes/pedpend/default.asp',
            deliveryPolicy: null,
          },
          {
            title: 'Reporte de Backorder cancelados',
            text: 'IR A VÍNCULO',
            color: '#F9BE00',
            url: 'http://200.79.162.123/reportes/folios/cancelados.asp',
            deliveryPolicy: null,
          },
          {
            title: 'Reporte precios X Ofi. Cite. GMat4',
            text: 'IR A VÍNCULO',
            color: '#1B998B',
            url: 'http://172.16.171.10/reportes/materiales/',
            deliveryPolicy: null,
          },
        ],
      };
    },
    mounted() {
      this.sendToPDF({ active: true });
    },
    methods: {
      ...mapActions({
        sendToPDF: 'printer/sendToPDF',
      }),
    },
  };
</script>
